module.exports = "/_next/static/images/dana-c3edbd17176c43a1d256a11ac43821c5.png";